module.exports = __webpack_public_path__ + "public/files/img/asks.3ea87cda.png";